"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _mobx = require("mobx");
var _config = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/config.store"));
var _currency = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/currency.store"));
var _country = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/country.store"));
var _flightInfo = _interopRequireDefault(require("@tajawal/web-flights-sdk/lib/stores/flight-info.store"));
var _googleTranslation = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/google-translation.store"));
var _profilePage = _interopRequireDefault(require("./profile-page.store"));
var _promoPage = _interopRequireDefault(require("./promo-page.store"));
var _loginPage = _interopRequireDefault(require("./login-page.store"));
var _registerPage = _interopRequireDefault(require("./register-page.store"));
var _forgotPasswordPage = _interopRequireDefault(require("./forgot-password-page.store"));
var _changePasswordPage = _interopRequireDefault(require("./change-password-page.store"));
var _resetPasswordPage = _interopRequireDefault(require("./reset-password-page.store"));
var _deleteAccountPage = _interopRequireDefault(require("./delete-account-page.store"));
var _verifyPage = _interopRequireDefault(require("./verify-page.store"));
var _travellersPage = _interopRequireDefault(require("./travellers-page.store"));
var _bookingPage = _interopRequireDefault(require("./booking-page.store"));
var _saleBookingsPage = _interopRequireDefault(require("./sale-bookings-page.store"));
var _walletPage = _interopRequireDefault(require("./wallet-page.store"));
var _loyaltyPage = _interopRequireDefault(require("./loyalty-page.store"));
var _manageHotelBooking = _interopRequireDefault(require("./manage-hotel-booking.store"));
var _manageFlightBookingPage = _interopRequireDefault(require("./manage-flight-booking-page.store"));
var _manageFlightOrderBookingPage = _interopRequireDefault(require("./manage-flight-order-booking-page.store"));
var _manageActivityBookingPage = _interopRequireDefault(require("./manage-activity-booking-page.store"));
var _kycPrefrencesPage = _interopRequireDefault(require("./kyc-prefrences-page.store"));
var _saleDetailsPage = _interopRequireDefault(require("./sale-details-page.store"));
var _bookingConfirmationPage = _interopRequireDefault(require("./booking-confirmation-page.store"));
var _activityBooking = _interopRequireDefault(require("./activity-booking.store"));
var _manageHotelOrderBooking = _interopRequireDefault(require("./manage-hotel-order-booking.store"));
var _creditCardPage = _interopRequireDefault(require("./credit-card-page.store"));
var _exploreActivities = _interopRequireDefault(require("./explore-activities.store"));
var _pointsExchangePage = _interopRequireDefault(require("./points-exchange-page.store"));
var _pointsExchangeEntryPage = _interopRequireDefault(require("./points-exchange-entry-page.store"));
var _pointsExchangeConfirmationPage = _interopRequireDefault(require("./points-exchange-confirmation-page.store"));
// stores

// import ManageHotelSaleBookingStore from './manage-hotel-sale-booking.store';

// import ManageAccommodationPageStore from './manage-accommadation-page.store';

(0, _mobx.configure)({
  enforceActions: 'observed'
});

/**
 * My Account store
 */
let MyAccountStore = /*#__PURE__*/(0, _createClass2.default)(
/**
 * constructor
 * @param {Object} initialState
 */
function MyAccountStore(initialState = {}) {
  (0, _classCallCheck2.default)(this, MyAccountStore);
  this.config = new _config.default(initialState.config);
  this.currency = new _currency.default(initialState.currency);
  this.country = new _country.default(initialState.country);
  const $env = {
    config: this.config,
    currency: this.currency
  };
  this.profilePage = new _profilePage.default(initialState.profilePage, $env);
  this.promoPage = new _promoPage.default(initialState.promoPage, $env);
  this.loginPage = new _loginPage.default(initialState.loginPage, $env);
  this.registerPage = new _registerPage.default(initialState.registerPage, $env);
  this.forgotPasswordPage = new _forgotPasswordPage.default(initialState.forgotPasswordPage, $env);
  this.resetPasswordPage = new _resetPasswordPage.default(initialState.resetPasswordPage, $env);
  this.changePasswordPageStore = new _changePasswordPage.default(initialState.changePasswordStore, $env);
  this.verifyPageStore = new _verifyPage.default(initialState.verifyPageStore, $env);
  this.deletePageStore = new _deleteAccountPage.default(initialState.deletePageStore, $env);
  this.walletPageStore = new _walletPage.default(initialState.walletPageStore, $env);
  this.travellersPage = new _travellersPage.default(initialState.travellersPage, $env);
  this.bookingPageStore = new _bookingPage.default(initialState.bookingPageStore, $env);
  this.saleBookingsPageStore = new _saleBookingsPage.default(initialState.saleBookingsPageStore, $env);
  this.manageHotelBookingStore = new _manageHotelBooking.default(initialState.manageHotelBookingStore, $env);
  this.manageFlightBookingPage = new _manageFlightBookingPage.default(initialState.manageFlightBookingPage, $env);
  // this.manageAccommodationBookingPage = new ManageAccommodationPageStore(
  //   initialState.manageAccommodationBookingPage,
  //   $env
  // );
  this.manageActivityBookingPage = new _manageActivityBookingPage.default(initialState.manageActivityBookingPage, $env);
  this.flightInfo = new _flightInfo.default(initialState.flightInfo, $env);
  this.KYCPrefrencesStore = new _kycPrefrencesPage.default(initialState.KYCPrefrencesStore, $env);
  this.manageOrderFlightBookingPage = new _manageFlightOrderBookingPage.default(initialState.manageOrderFlightBookingPage, $env);
  this.manageHotelOrderBookingPage = new _manageHotelOrderBooking.default(initialState.manageHotelOrderBookingPage, $env);
  this.saleDetailsPage = new _saleDetailsPage.default(initialState.saleDetailsPage, $env);
  this.bookingConfirmationPage = new _bookingConfirmationPage.default(initialState.bookingConfirmationPage, $env);
  this.activityBookingStore = new _activityBooking.default(initialState.activityBookingStore, $env);
  this.googleTranslation = new _googleTranslation.default(initialState.googleTranslation);
  this.creditCardPage = new _creditCardPage.default(initialState.creditCardPage);
  this.loyalty = new _loyaltyPage.default(initialState.loyalty);
  this.exploreActivitiesStore = new _exploreActivities.default(initialState.exploreActivitiesStore);
  this.pointsExchangePage = new _pointsExchangePage.default(initialState.pointsExchangePageStore, $env);
  this.pointsExchangeConfirmationPage = new _pointsExchangeConfirmationPage.default(initialState.pointsExchangeConfirmationPage, $env);
  this.pointsExchnageEntryPage = new _pointsExchangeEntryPage.default(initialState.pointsExchnageEntryPage, $env);
});
exports.default = MyAccountStore;